import { CustomerModel } from "../models/CustomerModel";
import { OfferModel } from "../models/OfferModel";
import apiService from "./apiService";

const customerService ={
    searchCustomers: async (offset: number, count: number, keyword: string) => {
        const response: { customers: any[], customerCount: number } = await apiService.get(`/SellerCustomer?offset=${offset}&count=${count}&keyword=${keyword}`);
        response.customers = response.customers.map((x) => new CustomerModel(x));
        return response;
    },
    getCustomerOffers: async (customerId: number, offset: number, count: number) => {
        const response: { offers: any[], offerCount: number } = await apiService.get(`/SellerCustomer/${customerId}/Offers?offset=${offset}&count=${count}`);
        response.offers = response.offers.map((x) => new OfferModel(x));
        return response;
    },
    updateCustomer: async (customerId: number, customerData: Partial<CustomerModel>) => {
        const response = await apiService.put(`/SellerCustomer/${customerId}`, customerData);
        return response;
    }
}
export default customerService;